/**
 * Forage Service
 * API calls for context-driven cross-era music discovery
 */

import { post } from '../lib/api-client';
import type { ForageRequest, ForageResponse } from '../types/forage.types';

/**
 * Perform a forage — context-driven cross-era discovery
 */
export async function performForage(request: ForageRequest): Promise<ForageResponse> {
  const response = await post<ForageResponse>('/forage', request);
  return response.data!;
}
